if (!customElements.get('tabs-content')) {
  customElements.define('tabs-content', class ProductForm extends HTMLElement {
    constructor() {
      super();

      const tabsLi = this.querySelectorAll('.tabs li');
      const accordionsHandle = this.querySelectorAll('.tab-handle');

      tabsLi.forEach((el) => {
        el.addEventListener('click', this.handleClick);
      })

      accordionsHandle.forEach((el) => {
        el.addEventListener('click', this.handleClickaccordion);
      })
    }

    handleClick = ({ currentTarget }) => {
      this.querySelector('.tabs li.active').classList.remove('active');
      currentTarget.classList.add('active');
      this.showContent();
    }

    handleClickaccordion = ({ currentTarget }) => {
      currentTarget.classList.toggle('active');
    }

    showContent() {
      const selectedTab = this.querySelector('.tabs li.active');
      this.querySelector('.tab-content.active').classList.remove('active');
      document.getElementById(selectedTab.dataset.target).classList.add('active');
    }
  });
}